import { RecordType } from '@xbcb/shared-types';
import { getRecordType } from '@xbcb/core';

export const getRedirectUrlForBroker = (customsBrokerId: string) => {
  let redirectURL = '/shipments';
  if (customsBrokerId) {
    const recordType = getRecordType(customsBrokerId) as RecordType;
    if (recordType === RecordType.DE_CUSTOMS_BROKER) {
      redirectURL = '/de-customs-entries';
    } else if (recordType === RecordType.UK_CUSTOMS_BROKER) {
      redirectURL = '/gb-customs-entries';
    } else if (recordType === RecordType.NL_CUSTOMS_BROKER) {
      redirectURL = '/nl-customs-entries';
    } else if (recordType === RecordType.FR_CUSTOMS_BROKER) {
      redirectURL = '/fr-customs-entries';
    }
  }

  return redirectURL;
};
